import { FormattedMessage } from 'react-intl';
import React from 'react';
import { convertDate } from '../../../../utils/utility';
import { AdultIcon, BabyIcon, ChildIcon } from '~svg';

const PassengerModal = ({
  passengerLst,
  direction = 'rtl',
  isMobile = false,
  modalID = '',
  darkMode = false,
  onCloseModal,
}) => {
  return (
    <div
      className={`d-flex align-items-center w-100`}
      style={{ overflowX: 'scroll' }}
    >
      <table
        className="w-100 table pt-0 table-striped text-center font-smaller table-bordered"
        style={{ minWidth: '1000px' }}
      >
        <thead
          className={`w-100 d-flex ${darkMode ? 'mobile-light-color' : ''}`}
        >
          <tr className="w-100 d-flex">
            <th className="col-1 px-0" scope="col">
              <FormattedMessage id="booking.index" />
            </th>
            <th className="col-1 px-0" scope="col">
              <FormattedMessage id="booking.passengertype" />
            </th>
            <th className="col-2 px-0" scope="col">
              <FormattedMessage id="booking.firstname" />
            </th>
            <th className="col-2 px-0" scope="col">
              <FormattedMessage id="user.lastname" />
            </th>
            <th className="col-2 px-0" scope="col">
              <FormattedMessage id="profile.nationalcode" />
            </th>
            <th className="col-2 px-0" scope="col">
              <FormattedMessage id="profile.passportNumber" />
            </th>
            <th className="col-1 px-0" scope="col">
              <FormattedMessage id="profile.birthdate" />
            </th>
            <th className="col-1 px-0" scope="col">
              <FormattedMessage id="booking.passportexpiredate" />
            </th>
          </tr>
        </thead>
        <tbody className={`w-100 d-flex ${darkMode ? 'text-white' : ''}`}>
          {passengerLst.map((item, index) => {
            return (
              <tr key={`row-${index}`} className="w-100 d-flex">
                <th
                  className="col-1 px-0 d-flex align-items-center justify-content-center"
                  scope="row"
                >
                  {index + 1}
                  {!isMobile ? (
                    <img
                      className="px-2"
                      src={require(`../../../../content/images/avatars/${item.avatar}`)}
                      alt="avatar"
                      style={{ width: 40 }}
                    />
                  ) : null}
                </th>

                <td className="col-1 px-0" scope="row">
                  {item.type === 'child' && (
                    <ChildIcon size={22} color="#6c757d" />
                  )}
                  {item.type === 'adult' && (
                    <AdultIcon size={22} color="#6c757d" />
                  )}
                  {item.type === 'infant' && (
                    <BabyIcon size={22} color="#6c757d" />
                  )}
                </td>
                <td className="col-2 px-0" scope="row">
                  {item.firstName}
                </td>
                <td className="col-2 px-0" scope="row">
                  {item.lastName}
                </td>
                <td className="col-2 px-0" scope="row">
                  {item.nationalCode ? item.nationalCode : '--'}
                </td>
                <td className="col-2 px-0" scope="row">
                  {item.passportNo ? item.passportNo : '--'}
                </td>
                <td className="col-1 px-0" scope="row">
                  {item.birthDate
                    ? direction === 'ltr'
                      ? item.birthDate
                      : convertDate(item.birthDate, 'en', 'fa')
                    : '--'}
                </td>
                <td className="col-1 px-0" scope="row">
                  {item.passportExpireDate
                    ? direction === 'ltr'
                      ? item.passportExpireDate
                      : convertDate(item.passportExpireDate, 'en', 'fa')
                    : '--'}
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

export default PassengerModal;
